import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'

import PeriodPicker from './PeriodPicker'
import UserSearch from './UserSearch'

import LogoutIcon from './icons/logout'

import { AuthContext } from '../../Login/context'

import Logo from './assets/logo.png'

import './index.scss'
import AccountSelector from './AccountSelector'

const Header = props => {
    const authContext = useContext(AuthContext)

    const { user } = props

    return (
        <div className='OperatorHeader'>
            <div className='OperatorHeader__logo'>
                <NavLink to='/' activeClassName='active-link'>
                    <img src={Logo} alt='pulsar logo' />
                </NavLink>
            </div>

            <PeriodPicker />

            <UserSearch />

            <AccountSelector />

            <div className='OperatorHeader__controls'>
                {user && <p>Hi, {user.FullName}</p>}

                <ul>
                    <li onClick={authContext.logout}>
                        <LogoutIcon />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default Header
